import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_UPCOMING_EVENTS_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUpcomingEvents = async (projectId: string): Promise<any> => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_UPCOMING_EVENTS_API(projectId)}`);
};

const useGetUpcomingEvents = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-pm-upcoming-events", projectId],
    queryFn: () => getUpcomingEvents(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetUpcomingEvents;
